const useStyles = {
  passcodeInput: {
    maxWidth: '50px',
    '& input': {
      textAlign: 'center',
    },
  },
  centeredRow: {
    justifyContent: 'center',
  },
  topSection: {
    justifyContent: 'center',
    marginTop: '40px',
  },
  passcodeFieldsRow: {
    flexWrap: 'nowrap',
    justifyContent: 'center',
    gap: '8px',
  },
  linksColumn: {
    flexDirection: 'column',
  },
}

export default useStyles
